import { Spinner as ChakraSpinner } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type SpinnerProps = ComponentPropsWithRef<typeof ChakraSpinner>;

export function Spinner(props: SpinnerProps) {
  return <ChakraSpinner {...props} />;
}
